import Head from 'next/head';
import { Fragment } from 'react';

type Props = {
  description?: string;
  openGraphImageUrl?: string;
  openToSearchEngines?: boolean;
  title?: string;
};

export const Meta = ({
  description,
  openGraphImageUrl,
  openToSearchEngines = false,
  title,
}: Props) => {
  return (
    <Head>
      {title && (
        <Fragment>
          <title>{title}</title>
          <meta content={title} property="og:title" />
          <meta content={title} name="twitter:title" />
        </Fragment>
      )}

      {description && (
        <Fragment>
          <meta
            content={description}
            id="meta-description"
            name="description"
          />
          <meta content={description} property="og:description" />
          <meta content={description} name="twitter:description" />
        </Fragment>
      )}

      {openGraphImageUrl && (
        <Fragment>
          <meta content={openGraphImageUrl} property="og:image" />
          <meta content={openGraphImageUrl} name="twitter:image" />
          <meta content="summary_large_image" name="twitter:card" />
        </Fragment>
      )}

      {!openToSearchEngines && (
        <meta content="noindex, nofollow" name="robots" />
      )}

      <meta content="width=device-width, initial-scale=1.0" name="viewport" />
    </Head>
  );
};
